module.exports = __webpack_public_path__ + "static/language-2-9276513be89fcda551285c2895626329.jpg";